export const DOUGS_PARTNER_FLOW_VARITAION = 'dougs';
